import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useTranslation } from 'react-i18next';
import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import {
	Drawer,
	DrawerContent,
	DrawerClose,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	Button,
	Close,
	DrawerDescription,
} from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

interface LevelUpProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LevelUp: React.FC<LevelUpProps> = ({
	isOpen,
	onClose,
}: LevelUpProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();
	const { levelsRequeriments } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Redux
	**********************/
	const { level, levelName, levelImage } = useCustomSelector(
		(state) => state.counter
	);

	/*********************
	// #region Template
	**********************/
	return (
		<Drawer open={isOpen} onOpenChange={onClose}>
			<DrawerContent>
				<div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" />
				<div className="mx-auto w-full max-w-sm ">
					<DrawerHeader>
						<DrawerTitle>
							<VisuallyHidden>
								{levelName} - {level} lvl
							</VisuallyHidden>
							<DrawerClose className="right-5 text-right absolute">
								<Close fillcolor="#fff" />
							</DrawerClose>
						</DrawerTitle>
					</DrawerHeader>
					<DrawerDescription>
						<VisuallyHidden>Level Up</VisuallyHidden>
					</DrawerDescription>

					<img
						className="cursor-pointer mx-auto w-[60%]"
						src={levelImage}
					/>
					<div className="mx-auto mb-5">
						<div className="flex flex-col text-center">
							<p className="font-bold text-3xl">Level Up</p>
							<p className="font-semibold text-base text-white text-center">
								{levelName} - {level} lvl
							</p>
						</div>
						<div className="mx-6 my-6">
							<hr />
						</div>
						<div className="flex flex-col mx-auto">
							<p className="text-center">
								Your rewards for leveling up
							</p>

							<div className="flex items-center gap-3 justify-center my-2">
								<img
									className="w-[40px]"
									src={process.env.VITE_MINI_DIAMOND_IMAGE}
									alt={process.env.VITE_COIN_NAME}
								/>
								<p className="font-bold text-2xl">
									{numify(
										levelsRequeriments[level - 1]
											.diamondsReward
									)}
								</p>
							</div>
						</div>
					</div>
					<DrawerFooter>
						<DrawerClose asChild>
							<Button
								variant="primary"
								className="py-6 w-full text-sm rounded-lg"
								onClick={() => onClose(false)}
							>
								{t('general.close')}
							</Button>
						</DrawerClose>
					</DrawerFooter>
				</div>
			</DrawerContent>
		</Drawer>
	);
};
